import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ICloseIncidentAction,
    ICloseIncidentSuccessAction,
    ICloseIncidentErrorAction
} from '../actions/close-incident';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type CloseIncidentAction
    = ICloseIncidentAction
    | ICloseIncidentSuccessAction
    | ICloseIncidentErrorAction;

const init = (state: ITicketsState, action: CloseIncidentAction) => ({
    ...state,
    closeIncident: {
        ...initialState.closeIncident,
        status: action.status
    }
});

const success = (state: ITicketsState, action: CloseIncidentAction) => {
    return {
        ...state,
        closeIncident: {
            ...initialState.closeIncident,
            status: action.status
        }
    };
};

const failure = (state: ITicketsState, action: CloseIncidentAction) => ({
    ...state,
    closeIncident: {
        ...initialState.closeIncident,
        status: action.status,
        error: (action as ICloseIncidentErrorAction).error
    }
});

const reset = (state: ITicketsState, action: CloseIncidentAction) => ({
    ...state,
    closeIncident: {
        status: action.status,
    }
});

export const closeIncidentReducer = createAsyncReducer(initialState, init, success, failure, reset);
